/**
 * WebSocketRouter Component
 * Installs the top-level WebSocket message router
 *
 * This component uses the useWebSocketRouter hook to handle
 * global WebSocket messages like user.joined, executor.invoked, etc.
 *
 * Must be placed inside WebSocketProvider in the component tree.
 * Renders children transparently (pass-through component).
 */

import { useWebSocketRouter } from '../hooks/useWebSocketRouter';
import type { ComponentChildren } from 'preact';

export function WebSocketRouter({ children }: { children: ComponentChildren }) {
  // Install global WebSocket message router
  useWebSocketRouter();

  // Pass through children (this is a side-effect only component)
  return <>{children}</>;
}
